module.exports = __webpack_public_path__ + "img/index_banner01.84779192.jpg";